import React from 'react'
import { Accordion } from 'react-bootstrap'


const accordData = [
  {
    head: "Intelligent Document Automation",
    para: 'Automate data capture, classification, workflows with minimal manual effort, reducing errors, delays, operational costs, compliance risks.',
    img: "/assets/images/home-redefine-img-1.webp"
  },
  {
    head: "Enterprise-Grade Data Security",
    para: 'Protect sensitive business information with advanced security protocols, controlled access, robust infrastructure.',
    img: "/assets/images/home-redefine-img-2.webp"
  },
  {
    head: "Centralized Document Control",
    para: 'Manage all your documents from a single, unified platform for better visibility, accessibility, operational efficiency.',
    img: "/assets/images/home-redefine-img-3.webp"
  },
  {
    head: "Scalable Business Solutions",
    para: 'Adapt and grow with flexible solutions designed to support evolving business needs and increasing data volumes.',
    img: "/assets/images/home-redefine-img-4.webp"
  },
]

const accordData2 = [
  {
    head: "Intelligent Access Control",
    para: 'Ensure secure and role-based access to documents while maintaining complete visibility and control across your organization.',
    img: "/assets/images/home-enterprize-img-1.webp"
  },
  {
    head: "Secure Document Storage",
    para: 'Store critical data in highly secure environments with structured organization and easy retrieval.',
    img: "/assets/images/home-enterprize-img-2.webp"
  },
  {
    head: "Workflow Automation",
    para: 'Optimize business processes by automating routine tasks and reducing manual intervention.',
    img: "/assets/images/home-enterprize-img-3.webp"
  },
  {
    head: "Compliance & Audit Readiness",
    para: 'Stay aligned with regulatory requirements through detailed audit trails and structured document governance.',
    img: "/assets/images/home-enterprize-img-4.webp"
  },
  {
    head: "Enterprise Integration",
    para: 'Seamlessly integrate with your existing systems to enable smooth data flow and improved operational efficiency.',
    img: "/assets/images/home-enterprize-img-5.webp"
  },
]

export default function HomeDocument() {
  const [activeKey, setActiveKey] = React.useState("0");
  const [activeKey2, setActiveKey2] = React.useState("0")
  return (
    <>
      <section className="home-document-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6">
              <div className="home-document-img">
                <img src={accordData[activeKey]?.img}
                  alt="Redefine" decoding="async"  loading="lazy" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="home-document-content">
                <h3 className="heading">Redefining Intelligent Document Management</h3>
                <p>Transform the way your business manages information with faster, smarter, more secure document solutions designed for modern enterprises.</p>
                <Accordion activeKey={activeKey} onSelect={(key) => setActiveKey(key ?? activeKey)}>
                  {accordData?.map((item, index) => (
                    <Accordion.Item key={index} eventKey={`${index}`} className={activeKey === `${index}` ? "active-accordion" : ""}>
                      <Accordion.Header>{item?.head}</Accordion.Header>
                      <Accordion.Body>{item?.para}</Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="home-document-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 order-1 order-md-0">
              <div className="home-document-content home-enterprise-content">
                <h3 className="heading">Enterprise-Grade Document Intelligence</h3>
                <p>Simplify document storage and streamline workflows with intelligent systems that help your business operate faster, safer, more efficiently.</p>

                <Accordion activeKey={activeKey2} onSelect={(key) => setActiveKey2(key ?? activeKey2)}>
                  {accordData2?.map((item, index) => (
                    <Accordion.Item key={index} eventKey={`${index}`} className={activeKey2 === `${index}` ? "active-accordion" : ""}>
                      <Accordion.Header>{item?.head}</Accordion.Header>
                      <Accordion.Body>{item?.para}</Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 order-0 order-md-1">
              <div className="home-document-img home-enterprise-img">
                {/* <img src="/assets/images/home-enterprize-2.webp" alt="redefine" decoding="async" loading='lazy' /> */}
                <img  src={accordData2[activeKey2]?.img}  alt="Redefine" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
